// TODO: break this up into multiple exports.  No need for default export.
const appConfig = {
  queryMatches: {
    distribution: 'd',
    indicators: 'i',
    geos: 'g',
    dataView: 'v',
    year: 'y',
  },
  apiUrl: {
    local: 'http://localhost:3000/api',
    staging: 'https://kff-cdr-staging.herokuapp.com/api',
    production: 'https://kff-cdr.herokuapp.com/api',
  },
  performanceWarning: {
    maxIndicators: 10,
    maxGeos: 20,
    selectStateWarning: 'You have selected a large number of indicators and are attempting to add many states to your report. For optimal performance, we recommend selecting fewer states or going back and removing indicators.',
  },
  loadingWarning: 'If your report is taking a long time to load, you may have selected a large number of indicators and/or states which could result in a long load time as well as sub-optimal performance when interacting with the data in the report. We suggest using your browser’s back button and selecting fewer states or removing indicators.',
  viewErrorText: {
    0: 'Please select at least one (1) category to continue.',
    1: 'Please select at least one (1) indicator to continue.',
    2: 'Please select at least one (1) state or "United States" to continue.',
  },
  errorStatusStrings: {
    429: 'Too many indicators were retuested.  Please reduce the scope of your report to continue.',
    500: 'An error has occurred while attempting to build your report due to an increase in the volume of requests for custom reports at this time.<br /><br />Your report may build faster if you try refreshing this page. If not, please use the browser\'s back button and try to rebuild your report.<br /><br />We apologize for the inconvenience.',
    503: 'Report failed to build.  Please re-try.  If possible, please reduce report scope.',
  },
};

export default appConfig;



// WEBPACK FOOTER //
// ./app/config/appConfig.js